import { render, staticRenderFns } from "./DataDefinition.vue?vue&type=template&id=a47a9a32"
import script from "./DataDefinition.vue?vue&type=script&lang=js"
export * from "./DataDefinition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports